
const MINIMUM_POWER_OPTIONS = ['all', 22, 50, 150, 300];

function storedMinimumPower() {
    try {
        const value = JSON.parse(localStorage.getItem('minimum_power'));

        return value === null || MINIMUM_POWER_OPTIONS.indexOf(value) >= 0 ? value : 'all';
    } catch (e) {
        return null;
    }
}

export const filters = {
    state: {
        //distanceFilter: '60',
        distanceFilter: JSON.parse(localStorage.getItem('distance')),
        minimumPowerOutputFilter: storedMinimumPower(),
        operatorsFilter: [],
        activeLocationFilter: 'all',
        orderBy: 'name',
        orderDirection: 'asc'
    },

    actions: {
        updateDistanceFilter({commit}, data) {
            commit('setDistanceFilter', data);
        },

        updateMinimumPowerFilter({commit}, data) {
            commit('setMinimumPowerFilter', data);
        },

        updateOperatorsFilter({ commit }, data) {
            commit('setOperatorsFilter', data);
        },

        updateActiveLocationFilter({commit}, data) {
            commit('setActiveLocationFilter', data);
        },

        updateOrderBy({commit, state, dispatch}, data) {
            commit('setOrderBy', data);
            dispatch('orderServices', {
                order: state.orderBy,
                direction: state.orderDirection
            });
        },

        updateOrderDirection({commit, state, dispatch}, data) {
            commit('setOrderDirection', data);
            dispatch('orderServices', {
                order: state.orderBy,
                direction: state.orderDirection
            });
        },

        resetFilters({commit}, data) {
            commit('resetFilters');
        }
    },

    mutations: {
        setDistanceFilter(state, distance) {
            if (distance) {
                localStorage.setItem('distance', JSON.stringify(distance));
            }

            state.distanceFilter = distance;
        },

        setMinimumPowerFilter(state, minPower) {
            if (minPower) {
                localStorage.setItem('minimum_power', JSON.stringify(minPower));
            }

            state.minimumPowerOutputFilter = minPower;
        },

        setOperatorsFilter(state, operators) {
            state.operatorsFilter = operators;
        },

        setActiveLocationFilter(state, activeLocationFilter) {
            state.activeLocationFilter = activeLocationFilter;
        },

        setOrderBy(state, orderBy) {
            state.orderBy = orderBy;
        },

        setOrderDirection(state, orderDirection) {
            state.orderDirection = orderDirection;
        },

        resetFilters(state) {
            state.distanceFilter = '10';
            state.minimumPowerOutputFilter = 'all';
            state.operatorsFilter = [];
            state.activeLocationFilter = 'all';
            state.orderBy = 'name';
            state.orderDirection = 'desc';
        }
    },

    getters: {
        getDistanceFilter(state) {
            return state.distanceFilter;
        },

        getMinimumPowerFilter(state) {
            return state.minimumPowerOutputFilter;
        },

        getOperatorsFilter(state) {
            return state.operatorsFilter;
        },

        getActiveLocationFilter(state) {
            return state.activeLocationFilter;
        },

        getOrderBy(state) {
            return state.orderBy;
        },

        getOrderDirection(state) {
            return state.orderDirection;
        }
    }
}
